// extracted by mini-css-extract-plugin
module.exports = {"page":"orders_page__j8Ngq","orders":"orders_orders__KqF-Z","order-details-wrapper":"orders_order-details-wrapper__3iXL3","order-list":"orders_order-list__1JiQ_"};